import React, { useCallback, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';
import { klona } from 'klona';

// store
import { storeSet } from '../../store';

// service
import UsersService from '../../service/users-service';

// components
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';
import UserAvatar from '../UserAvatar';

const ModalModifyTeam = ({
                             projectId = 0,
                             headerText = __('Modifica Team', 'soundbetween')
                         }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { isValid }
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            teamMembers: [],
            notes: ''
        }
    });

    const onSubmit = useCallback((formData) => {
        const updatedFormData = klona({ ...formData });
        const invitations = updatedFormData.teamMembers.map(s => ({ user_id: s, role: 'CUSTOMER' }))
        storeSet('createInvitationsBulkForProject', projectId, { invitations });
    }, [projectId]);

    const handleCreateNew = () => {
        setModalVisible(true);
    }

    // Search function for team members
    const searchTeamMembers = async (keyword) => {
        try {
            const response = await UsersService.getUsersAsync([['name', keyword]]);

            // Transform response to match expected format
            if (response) {
                return response.map(member => ({
                    ...member,
                    value: member.id,
                    label: `${member.name || ''} ${member.surname || ''}`.trim() || member.email
                }));
            }

            return [];
        } catch (error) {
            console.error('Error searching team members:', error);
            return [{
                value: 'no_matches',
                label: __('Nessun risultato trovato', 'soundbetween')
            }];
        }
    };

    // Custom render for selected items with avatars
    const renderSelectedUser = (user, handleRemove) => {
        return (
            <>
                <UserAvatar
                    url={user.profile_picture_url}
                    name={user.label}
                />
                <span className="multiSelectDropdown__selectedItemLabel">
                    {user.label}
                </span>
                <button
                    type="button"
                    onClick={() => handleRemove(user.value)}
                    className="multiSelectDropdown__removeBtn"
                    aria-label={__('Rimuovi utente', 'soundbetween')}
                />
            </>
        );
    };

    return (
        <>
            <ButtonFlat
                onClick={handleCreateNew}>
                {__('Modifica', 'soundbetween')}
            </ButtonFlat>
            {modalVisible
                ? <ModalDialog
                    additionalClasses={['modalCreateProject']}
                    header={headerText}
                    visible={modalVisible}
                    onHide={() => {
                        if (!modalVisible) return;
                        setModalVisible(false);
                    }}>
                    <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                        <FormField
                            type="multiselect"
                            name="teamMembers"
                            label={__('Seleziona Membri del Team', 'soundbetween')}
                            control={control}
                            searchFn={searchTeamMembers}
                            labelKey="label"
                            valueKey="value"
                            placeholder={__('Cerca membri...', 'soundbetween')}
                            displayMode="count"
                            showClearAll={true}
                            minSearchLength={2}
                            renderSelectedItem={renderSelectedUser}
                            rules={{
                                required: __('Seleziona almeno un membro', 'soundbetween')
                            }}
                        />

                        <FormField
                            type="textarea"
                            name="notes"
                            rows={7}
                            label={__('Aggiungi note', 'soundbetween')}
                            control={control}
                            config={{ required: __('È obbligatorio', 'soundbetween') }}
                        />

                        <div className="appFormActions">
                            <ButtonFlat size="lg" type="button" onClick={() => {
                                if (!modalVisible) return;
                                setModalVisible(false);
                            }}>
                                {__('Anulla', 'soundbetween')}
                            </ButtonFlat>
                            <ButtonFormSubmit disabled={loading || !isValid}>
                                {__('Salva', 'soundbetween')}
                            </ButtonFormSubmit>
                        </div>
                    </form>
                </ModalDialog> : null}
        </>
    )
}

export default ModalModifyTeam;